import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const LocationBoldIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.364 17.3639L12 23.7279L5.636 17.3639C2.12131 13.8492 2.12134 8.15073 5.63605 4.63603C9.15077 1.12132 14.8492 1.12132 18.3639 4.63603C21.8787 8.15073 21.8787 13.8492 18.364 17.3639ZM12 14.9999C14.2091 14.9999 16 13.2091 16 10.9999C16 8.79078 14.2091 6.99992 12 6.99992C9.79086 6.99992 8 8.79078 8 10.9999C8 13.2091 9.79086 14.9999 12 14.9999ZM12 12.9999C10.8954 12.9999 10 12.1045 10 10.9999C10 9.89535 10.8954 8.99992 12 8.99992C13.1046 8.99992 14 9.89535 14 10.9999C14 12.1045 13.1046 12.9999 12 12.9999Z"
        fill={color}
      />
    </svg>
  );
};
